import { createContext, useContext, useRef, useState } from 'react';
import { loadSettings } from '../omnibox_json_converter/converterHelperFunctions';

const ConverterContext = createContext();

export function OmniboxJsonConverterProvider({ children }) {
  const [inputFiles, setInputFiles] = useState([]);
  const filesRef = useRef(null);
  const [globalColumns, setGlobalColumns] = useState([]);
  const [selectedColumns, setSelectedColumns] = useState([]);
  const [displayOrder, setDisplayOrder] = useState([]);
  const [selectedSetting, setSelectedSetting] = useState('');
  const [detectedTechnique, setDetectedTechnique] = useState('CMC');
  const [openColumnsDialog, setOpenColumnsDialog] = useState(false);
  const [openAddTemplate, setOpenAddTemplate] = useState(false);
  const [openRenameTemplate, setOpenRenameTemplate] = useState(false);
  const [columnsExist, setColumnsExist] = useState(false);
  const [displayResults, setDisplayResults] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');

  const handleOpenColumnsDialog = () => setOpenColumnsDialog(true);
  const handleCloseColumnsDialog = () => setOpenColumnsDialog(false);
  const handleOpenAddTemplate = () => setOpenAddTemplate(true);
  const handleCloseAddTemplate = () => setOpenAddTemplate(false);
  const handleOpenRenameTemplate = () => setOpenRenameTemplate(true);
  const handleCloseRenameTemplate = () => setOpenRenameTemplate(false);

  const resetAppState = () => {
    setInputFiles([]);
    // filesRef.current = null;
    setGlobalColumns([]);
    setSelectedColumns([]);
    setSelectedSetting('');
    setDetectedTechnique('CMC');
  }

  const value = {
    inputFiles, setInputFiles, 
    filesRef,
    globalColumns, setGlobalColumns,
    selectedColumns, setSelectedColumns,
    displayOrder, setDisplayOrder,
    selectedSetting, setSelectedSetting,
    detectedTechnique, setDetectedTechnique,
    
    openColumnsDialog, handleOpenColumnsDialog, handleCloseColumnsDialog,
    openAddTemplate, handleOpenAddTemplate, handleCloseAddTemplate,
    openRenameTemplate, handleOpenRenameTemplate, handleCloseRenameTemplate,
    columnsExist, setColumnsExist,
    displayResults, setDisplayResults,
    searchQuery, setSearchQuery,

    resetAppState,
  };

  return (
    <ConverterContext.Provider value={value}>
      {children}
    </ConverterContext.Provider>
  )
}

export function useAppState() {
  return useContext(ConverterContext);
}